import validateNumber, {
  ValidateOptions,
  ValidNumberOption,
} from '@sdk/utils/validation/validateNumber';

export const validateRestBreakThreshold = (value: string | number): boolean => {
  return validateNumber(value, {
    [ValidateOptions.validNumber]: ValidNumberOption.nonNegative,
    [ValidateOptions.integer]: true,
  });
};

export const validateConsecutiveWorkDaysLimitThreshold = (value: string | number): boolean => {
  return validateNumber(value, {
    [ValidateOptions.validNumber]: ValidNumberOption.nonNegative,
    [ValidateOptions.integer]: true,
  });
};

export const getRestBreakThresholdHours = (value: number | string): number | string => {
  if (validateRestBreakThreshold(value)) {
    return Number(value) / 60;
  }
  return value;
};

export const setRestBreakThresholdHours = (value: number | string): number => {
  return Number(value) * 60;
};
